module.exports = __webpack_public_path__ + "img/ic_brandstory.ceba9fff.svg";